import formValidator, {
	required,
	and,
	isCorrectEmailLen,
	maxLen,
	isEmail,
} from "@insightfulscience/shared-utils/validation";
import parseNumber from "@insightfulscience/shared-utils/parsers/parseNumber";

export const getInitialState = (customerData, countryById) => {
	const countryID = parseNumber(customerData?.countryID, "");
	return {
		...customerData,
		numberOfLicenses: 0,
		countryID,
		address1: countryById.get(countryID)?.name,
	};
};

export const userTypes = [
	{ text: "USER_TYPES.ACADEMIC", value: "academic" },
	{ text: "USER_TYPES.COMMERCIAL", value: "commercial" },
];

export const productOfInterest = [
	{ text: "PRODUCT_OF_INTEREST_OPTION.GENEIOUS_PRIME", value: "geneious_prime" },
	{ text: "PRODUCT_OF_INTEREST_OPTION.GENEIOUS_BIOLOGICS", value: "geneious_biologics" },
];

const schema = {
	email: [
		[required, "errors.EMAIL_REQUIRED"],
		[isCorrectEmailLen(64), "errors.EMAIL_INVALID_LENGTH"],
		[email => isEmail(email), "errors.EMAIL_INVALID"],
		[maxLen(100), "errors.WRONG_EMAIL"],
	],
	firstName: [required, "errors.FIRST_NAME_REQUIRED"],
	lastName: [required, "errors.LAST_NAME_REQUIRED"],
	company: [required, "errors.COMPANY_REQUIRED"],
	countryID: [and(required, value => value > 0), "errors.COUNTRY_REQUIRED"],
	state: [
		(state, { countryID }) => ![220, 38].includes(countryID) || required(state), // state is required only if country = US or Canada
		"errors.STATE_REQUIRED",
	],
	productOfInterest: [required, "errors.PRODUCT_OF_INTEREST_REQUIRED"],
	userType: [required, "errors.USER_TYPE_REQUIRED"],
	numberOfLicenses: [
		numberOfLicenses => required(numberOfLicenses < 1 && null),
		"errors.NUMBER_OF_LICENSES_REQUIRED",
	],
};

export const validateForm = formValidator(schema);
